import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        green_300:
          "border-transparent bg-green-300 text-green-300-foreground shadow hover:bg-green-300/80",
        lime_400:
          "border-transparent bg-lime-400 text-lime-400-foreground shadow hover:bg-lime-400/80",
        green_400:
          "border-transparent bg-green-400 text-green-400-foreground shadow hover:bg-green-400/80",
        red_400:
          "border-transparent bg-red-400 text-red-400-foreground shadow hover:bg-red-400/80",
        yellow_400:
          "border-transparent bg-yellow-400 text-yellow-400-foreground shadow hover:bg-yellow-400/80",
        orange_400:
          "border-transparent bg-orange-400 text-orange-400-foreground shadow hover:bg-orange-400/80",
        red_300:
          "border-transparent bg-red-300 text-red-300-foreground shadow hover:bg-red-300/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
